

// // import React, { useState, useEffect } from "react";
// // import { FaEdit, FaTrash, FaTimes } from "react-icons/fa";

// // /* ===== SIDEBAR PERMISSIONS ===== */
// // const sidebarComponents = [
// //   "Dashboard",
// //   "Lead Management",
// //   "Customer Management (CRM)",
// //   "Master Management",
// //   "Category",
// //   "Product Master",
// //   "Inventory Master",
// //   "Master GST",
// //   "Sales Order Management",
// //   "Quotation & Invoicing",
// //   "Follow-ups & Reminders",
// //   "Reports & Analytics",
// //   "User Roles & Permissions",
// // ];

// // const UserRoles = () => {
// //   const [users, setUsers] = useState([]);
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [loading, setLoading] = useState(false);
// //   const [editUser, setEditUser] = useState(null);

// //   /* ==== FORM STATES ==== */
// //   const [form, setForm] = useState({
// //     name: "",
// //     email: "",
// //     mobile: "",
// //     gender: "",
// //     userType: "",
// //     password: "",
// //     confirmPassword: "",
// //     permissions: [],
// //   });

// //   useEffect(() => {
// //     fetchUsers();
// //   }, []);

// // const fetchUsers = async () => {
// //     setLoading(true);
// //     try {
// //         const user = JSON.parse(sessionStorage.getItem("userData"));
// //         const userId = user?.id;

// //         if (!userId) throw new Error("User not logged in");

// //         const res = await fetch(
// //             `https://cloudapi.emedhatechnologies.com/pages/api/get/users?user_id=${userId}`
// //         );
// //         setUsers(await res.json());
// //     } catch (e) {
// //         console.error(e);
// //         alert("Failed to load users.");
// //     }
// //     setLoading(false);
// // };

// //   /* ====== Modal Open for Create ====== */
// //   const openAddModal = () => {
// //     setEditUser(null);
// //     setForm({
// //       name: "",
// //       email: "",
// //       mobile: "",
// //       gender: "",
// //       userType: "",
// //       password: "",
// //       confirmPassword: "",
// //       permissions: [],
// //     });
// //     setModalOpen(true);
// //   };

// //   /* ====== Modal Open for Edit ====== */
// //   const openEditModal = (user) => {
// //     setEditUser(user);
// //     setForm({
// //       name: user.name || "",
// //       email: user.email,
// //       mobile: user.mobile || "",
// //       gender: user.gender || "",
// //       userType: user.user_type || "",
// //       password: user.password,
// //       confirmPassword: user.password,
// //       permissions: user.permissions || [],
// //     });
// //     setModalOpen(true);
// //   };

// //   /* ====== Handle Form Fields ====== */
// //   const updateField = (field, value) =>
// //     setForm({ ...form, [field]: value });

// //   const togglePermission = (p) => {
// //     setForm((prev) => ({
// //       ...prev,
// //       permissions: prev.permissions.includes(p)
// //         ? prev.permissions.filter((x) => x !== p)
// //         : [...prev.permissions, p],
// //     }));
// //   };

// //   /* ===== SUBMIT ===== */
// // const handleSubmit = async (e) => {
// //   e.preventDefault();

// //   if (form.password !== form.confirmPassword) {
// //     alert("Passwords do not match!");
// //     return;
// //   }

// //   const user = JSON.parse(sessionStorage.getItem("userData"));

// //   const payload = {
// //     ...form,
// //     user_type: form.userType,   // 🔥 FIXED: correct key for backend
// //     user_id: user?.id,
// //   };

// //   delete payload.userType;
// //   delete payload.confirmPassword;

// //   try {
// //     let res;

// //     if (editUser) {
// //       res = await fetch(
// //         `https://cloudapi.emedhatechnologies.com/pages/api/update/users/${editUser.id}`,
// //         {
// //           method: "PUT",
// //           headers: { "Content-Type": "application/json" },
// //           body: JSON.stringify(payload),
// //         }
// //       );
// //     } else {
// //       res = await fetch("https://cloudapi.emedhatechnologies.com/pages/api/add/users/", {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify(payload),
// //       });
// //     }

// //     if (!res.ok) throw new Error();

// //     await fetchUsers();
// //     setModalOpen(false);
// //     alert(editUser ? "User updated!" : "User added!");
// //   } catch (e) {
// //     console.error(e);
// //     alert("Failed to save user.");
// //   }
// // };



// //   /* ===== DELETE USER ===== */
// //   const handleDelete = async (id) => {
// //     if (!window.confirm("Delete this user?")) return;

// //     try {
// //       await fetch(
// //         `https://cloudapi.emedhatechnologies.com/pages/api/userspermissions/${id}`,
// //         { method: "DELETE" }
// //       );

// //       setUsers((prev) => prev.filter((u) => u.id !== id));
// //       alert("User deleted.");
// //     } catch (e) {
// //       alert("Failed to delete.");
// //     }
// //   };

// //   return (
// //     <div style={{ padding: 20, fontFamily: "Arial" }}>
// //       {/* HEADER */}
// //       <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
// //         <h2 style={{ color: "var(--dark)" }}>User Roles & Permissions</h2>

// //         <button
// //           onClick={openAddModal}
// //           style={{
// //             background: "#02adf0",
// //             color: "white",
// //             padding: "10px 10px",
// //             borderRadius: 10,
// //             border: "none",
// //             cursor: "pointer",
// //             fontWeight: "bold",
// //             height:'40px'
// //           }}
// //         >
// //           Add User
// //         </button>

// //       </div>

// //       {/* USERS TABLE */}
// //       <div
// //         style={{
// //           background: "var(--card-bg)",
// //           padding: 20,
// //           borderRadius: 10,
// //           boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
// //         }}
// //       >
// //         {loading ? (
// //           <p>Loading...</p>
// //         ) : (
// //           <table style={{ width: "100%", fontSize: 14, borderCollapse: "collapse" }}>
// //             <thead>
// //               <tr style={{ background: "var(--hover)" }}>
// //                 <th style={th}>#</th>
// //                 <th style={th}>Name</th>
// //                 <th style={th}>Email</th>
// //                 <th style={th}>Mobile</th>
// //                 <th style={th}>User Type</th>

// //                 <th style={th}>Actions</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {users.map((u) => (
// //                 <tr key={u.id} style={{ borderBottom: "1px solid var(--border)" }}>
// //                   <td style={td}>{u.id}</td>
// //                   <td style={td}>{u.name}</td>
// //                   <td style={td}>{u.email}</td>
// //                   <td style={td}>{u.mobile}</td>
// //                   <td style={td}>{u.user_type}</td>

// //                   <td style={td}>
// //                     <button onClick={() => openEditModal(u)} style={btnEdit}><FaEdit /></button>
// //                     <button disabled onClick={() => handleDelete(u.id)} style={btnDelete}><FaTrash /></button>
// //                   </td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         )}
// //       </div>

// //       {/* ================= MODAL ================= */}
// //       {modalOpen && (
// //         <div style={modalOverlay}>
// //           <div style={modalBox}>
// //             <div style={modalHeader}>
// //               <h3 style={{ margin: 0 }}>
// //                 {editUser ? "Edit User" : "Add New User"}
// //               </h3>
// //               <FaTimes style={{ cursor: "pointer" }} onClick={() => setModalOpen(false)} />
// //             </div>

// //             <form onSubmit={handleSubmit} style={{ marginTop: 10 }}>
// //               {/* INPUT GRID */}
// //               <div style={formGrid}>
// //                 <Input label="Name" value={form.name} onChange={(v) => updateField("name", v)} required />
// //                 <Input label="Email" type="email" value={form.email} onChange={(v) => updateField("email", v)} required />
// //                 <Input label="Mobile" value={form.mobile} onChange={(v) => updateField("mobile", v)} required />

// //                 <Select label="Gender" value={form.gender} onChange={(v) => updateField("gender", v)}
// //                   options={["Male", "Female", "Other"]} required />

// //                 <Select label="User Type" value={form.userType} onChange={(v) => updateField("userType", v)}
// //                   options={["Manager", "Executive"]} required />

// //                 <Input label="Password" type="password" value={form.password} onChange={(v) => updateField("password", v)} required />
// //                 <Input label="Confirm Password" type="password" value={form.confirmPassword} onChange={(v) => updateField("confirmPassword", v)} required />
// //               </div>

// //               <h4 style={{ marginTop: 20, color: "var(--primary)" }}>Assign Permissions</h4>
// //            <div
// //   style={{
// //     display: "grid",
// //     gridTemplateColumns: "repeat(2, 1fr)",  // ✅ Always 2 columns
// //     gap: 10,
// //   }}
// // >

// //                 {sidebarComponents.map((p) => (
// //                   <label key={p} style={{ display: "flex", alignItems: "center", gap: 8 }}>
// //                     <input
// //                       type="checkbox"
// //                       checked={form.permissions.includes(p)}
// //                       onChange={() => togglePermission(p)}
// //                     />
// //                     {p}
// //                   </label>
// //                 ))}
// //               </div>

// //               <button type="submit" style={btnSubmit}>
// //                 {editUser ? "Update User" : "Save User"}
// //               </button>
// //             </form>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // /* Reusable Components */
// // const Input = ({ label, type = "text", value, onChange, required }) => (
// //   <div style={{ display: "flex", flexDirection: "column" }}>
// //     <label>{label}</label>
// //     <input
// //       type={type}
// //       required={required}
// //       value={value}
// //       onChange={(e) => onChange(e.target.value)}
// //       style={inputStyle}
// //     />
// //   </div>
// // );

// // const Select = ({ label, value, onChange, options }) => (
// //   <div style={{ display: "flex", flexDirection: "column" }}>
// //     <label>{label}</label>
// //     <select value={value} onChange={(e) => onChange(e.target.value)} style={inputStyle}>
// //       <option value="">Select</option>
// //       {options.map((o) => (
// //         <option key={o} value={o}>{o}</option>
// //       ))}
// //     </select>
// //   </div>
// // );

// // /* ====== STYLES ====== */
// // const th = { padding: 10, textAlign: "left", fontWeight: "bold" };
// // const td = { padding: 10 };
// // const btnEdit = { background: "var(--accent)", border: "none", color: "white", padding: 6, borderRadius: 6, cursor: "pointer", marginRight: 8 };
// // const btnDelete = { background: "#dc3545", border: "none", color: "white", padding: 6, borderRadius: 6, cursor: "not-allowed" };

// // /* FIX: Modal appearing under sidebar */
// // const modalOverlay = {
// //   position: "fixed",
// //   top: 0,
// //   left: 0,
// //   width: "100vw",
// //   height: "100vh",
// //   background: "rgba(0,0,0,0.55)",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   zIndex: 99999, // 🔥 Increased so it stays above sidebar
// // };


// // /* Responsive & prevents going under sidebar */
// // const modalBox = {
// //   background: "white",
// //   width: "90%",         // 🔥 Makes responsive
// //   maxWidth: "600px",    // 🔥 Keeps desktop width
// //   borderRadius: 12,
// //   padding: 20,
// //   maxHeight: "85vh",
// //   overflowY: "auto",    // 🔥 Prevents overflow on smaller screens
// //   boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
// //   zIndex: 100000,       // Extra safety
// // };


// // const modalHeader = {
// //   display: "flex",
// //   justifyContent: "space-between",
// //   alignItems: "center",
// //   borderBottom: "1px solid #ddd",
// //   paddingBottom: 10,
// // };

// // /* Responsive form fields */
// // const formGrid = {
// //   display: "grid",
// //   gridTemplateColumns: "1fr 1fr",
// //   gap: 15,
// // };



// // const inputStyle = {
// //   padding: 10,
// //   borderRadius: 6,
// //   border: "1px solid #ccc", 
// //   fontSize: 14,
// // };

// // const btnSubmit = {
// //   marginTop: 20,
// //   width: "100%",
// //   background: "#02adf0",
// //   color: "white",
// //   padding: "12px",
// //   borderRadius: 8,
// //   border: "none",
// //   cursor: "pointer",
// //   fontSize: 16,
// //   fontWeight: "bold",
// // };

// // export default UserRoles;




// import React, { useState, useEffect } from "react";
// import { FaEdit, FaTrash, FaTimes } from "react-icons/fa";

// /* ===== SIDEBAR PERMISSIONS ===== */
// const sidebarComponents = [
//   "Dashboard",
//   "Lead Management",
//   "Customer Management (CRM)",
//   "Master Management",
//   "Category",
//   "Product Master",
//   "Inventory Master",
//   "Master GST",
//   "Sales Order Management",
//   "Quotation & Invoicing",
//   "Follow-ups & Reminders",
//   "Reports & Analytics",
//   "User Roles & Permissions",
// ];

// const UserRoles = () => {
//   const [users, setUsers] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [editUser, setEditUser] = useState(null);
//   // 🔥 Manager dropdown data
//   const [managers, setManagers] = useState([]);


//   /* ==== FORM STATES ==== */
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     mobile: "",
//     gender: "",
//     userType: "",
//     managerId: "",
//     password: "",
//     confirmPassword: "",
//     permissions: [],
//   });

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     setLoading(true);
//     try {
//       const user = JSON.parse(sessionStorage.getItem("userData"));
//       const userId = user?.id;

//       if (!userId) throw new Error("User not logged in");

//       const res = await fetch(
//         `https://cloudapi.emedhatechnologies.com/pages/api/get/users?user_id=${userId}`
//       );
//       setUsers(await res.json());
//     } catch (e) {
//       console.error(e);
//       alert("Failed to load users.");
//     }
//     setLoading(false);
//   };



//   // 🔥 Fetch managers for logged-in user
//   const fetchManagers = async () => {
//     try {
//       const user = JSON.parse(sessionStorage.getItem("userData"));
//       const userId = user?.id;

//       if (!userId) return;

//       const res = await fetch(
//         `https://cloudapi.emedhatechnologies.com/pages/api/get/managers?user_id=${userId}`
//       );

//       setManagers(await res.json());
//     } catch (err) {
//       console.error("Failed to fetch managers", err);
//     }
//   };

//   useEffect(() => {
//     if (form.userType === "Executive") {
//       fetchManagers();   // 🔥 load managers only when needed
//     }
//   }, [form.userType]);


//   /* ====== Modal Open for Create ====== */
//   const openAddModal = () => {
//     setEditUser(null);
//     setForm({
//       name: "",
//       email: "",
//       mobile: "",
//       gender: "",
//       userType: "",
//       password: "",
//       confirmPassword: "",
//       permissions: [],
//     });
//     setModalOpen(true);
//   };

//   /* ====== Modal Open for Edit ====== */
//   const openEditModal = (user) => {
//     setEditUser(user);
//     setForm({
//       name: user.name || "",
//       email: user.email,
//       mobile: user.mobile || "",
//       gender: user.gender || "",
//       userType: user.user_type || "",
//       managerId: user.manager_id || "", // 🔥 NEW
//       password: user.password,
//       confirmPassword: user.password,
//       permissions: user.permissions || [],
//     });
//     setModalOpen(true);
//   };

//   /* ====== Handle Form Fields ====== */
//   const updateField = (field, value) =>
//     setForm({ ...form, [field]: value });

//   const togglePermission = (p) => {
//     setForm((prev) => ({
//       ...prev,
//       permissions: prev.permissions.includes(p)
//         ? prev.permissions.filter((x) => x !== p)
//         : [...prev.permissions, p],
//     }));
//   };

//   /* ===== SUBMIT ===== */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (form.password !== form.confirmPassword) {
//       alert("Passwords do not match!");
//       return;
//     }

//     const user = JSON.parse(sessionStorage.getItem("userData"));

//     const payload = {
//       ...form,
//       user_type: form.userType,
//       manager_id: form.userType === "Executive" ? form.managerId : null, // 🔥
//       // 🔥 FIXED: correct key for backend
//       user_id: user?.id,
//     };

//     delete payload.userType;
//     delete payload.confirmPassword;

//     try {
//       let res;

//       if (editUser) {
//         res = await fetch(
//           `https://cloudapi.emedhatechnologies.com/pages/api/update/users/${editUser.id}`,
//           {
//             method: "PUT",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(payload),
//           }
//         );
//       } else {
//         res = await fetch("https://cloudapi.emedhatechnologies.com/pages/api/add/users/", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//       }

//       if (!res.ok) throw new Error();

//       await fetchUsers();
//       setModalOpen(false);
//       alert(editUser ? "User updated!" : "User added!");
//     } catch (e) {
//       console.error(e);
//       alert("Failed to save user.");
//     }
//   };



//   /* ===== DELETE USER ===== */
//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this user?")) return;

//     try {
//       await fetch(
//         `https://cloudapi.emedhatechnologies.com/pages/api/userspermissions/${id}`,
//         { method: "DELETE" }
//       );

//       setUsers((prev) => prev.filter((u) => u.id !== id));
//       alert("User deleted.");
//     } catch (e) {
//       alert("Failed to delete.");
//     }
//   };

//   return (
//     <div style={{ fontFamily: "Arial", }}>
//       {/* HEADER */}
//       {/* https://cloudapi.emedhatechnologies.com */}
//       {/* https://cloudapi.emedhatechnologies.com */}
      
//       <div>
//         {/* HEADER */}
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: "10px", }}>
//           <h4>User Roles & Permissions</h4>
//           <button onClick={openAddModal} style={{ background: "#02adf0", color: "white", padding: "10px 14px", borderRadius: 10, border: "none", cursor: "pointer", fontWeight: "bold", height: "40px", width: "100%", maxWidth: "160px", }}>Add User</button>
//         </div>

//         {/* USERS CARDS */}
//         <div style={{ display: "flex", flexDirection: "column", gap: "12px", background: "#f4f6f8", borderRadius: "10px", }}>
//           {loading ? (
//             <div style={{ padding: "20px", textAlign: "center" }}>Loading...</div>
//           ) : users.length === 0 ? (
//             <div style={{ padding: "20px", textAlign: "center" }}>No users found</div>
//           ) : (
//             users.map((u, index) => (
//               <div key={u.id} style={{ background: "#fff", borderRadius: "12px", padding: "12px", boxShadow: "0 2px 6px rgba(0,0,0,0.08)", border: "1px solid #ddd", }}>
//                 {/* TOP ROW */}
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px", }}>
//                   <strong>#{index + 1}</strong>
//                   <span style={{ background: "#e9ecef", padding: "4px 10px", borderRadius: "20px", fontSize: "12px", }}>{u.user_type}</span>
//                 </div>
//                 {/* DETAILS */}
//                 <div style={{ marginBottom: "6px" }}><strong>Name:</strong> {u.name}</div>
//                 <div style={{ marginBottom: "6px" }}><strong>Email:</strong> {u.email}</div>
//                 <div style={{ marginBottom: "6px" }}><strong>Mobile:</strong> {u.mobile}</div>
//                 {/* ACTIONS */}
//                 <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//                   <button onClick={() => openEditModal(u)} style={{ background: "var(--accent)", border: "none", color: "white", padding: "6px 10px", borderRadius: "50px", cursor: "pointer", }}><FaEdit size={14} /></button>
//                   <button disabled onClick={() => handleDelete(u.id)} style={{ background: "#dc3545", border: "none", color: "white", padding: "6px 10px", borderRadius: "50px", cursor: "not-allowed", opacity: 0.6, }}><FaTrash size={14} /></button>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>



//       {/* ================= MODAL ================= */}
//       {modalOpen && (
//         <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 99999, }}>
//           <div style={{ background: "white", width: "90%", maxWidth: "600px", borderRadius: 12, padding: 20, maxHeight: "85vh", overflowY: "auto", boxShadow: "0 10px 25px rgba(0,0,0,0.25)", zIndex: 100000, }}>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #ddd", paddingBottom: 10, }}>
//               <h3 style={{ margin: 0 }}>
//                 {editUser ? "Edit User" : "Add New User"}
//               </h3>
//               <FaTimes style={{ cursor: "pointer" }} onClick={() => setModalOpen(false)} />
//             </div>

//             <form onSubmit={handleSubmit} style={{ marginTop: 10 }}>
//               {/* INPUT GRID */}
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 15, }}>
//                 <Input label="Name" value={form.name} onChange={(v) => updateField("name", v)} required />
//                 <Input label="Email" type="email" value={form.email} onChange={(v) => updateField("email", v)} required />
//                 <Input label="Mobile" value={form.mobile} onChange={(v) => updateField("mobile", v)} required />
//                 <Select label="Gender" value={form.gender} onChange={(v) => updateField("gender", v)} options={["Male", "Female", "Other"]} required />
//                 <Select label="User Type" value={form.userType} onChange={(v) => updateField("userType", v)} options={["Manager", "Executive"]} required />
//                 {form.userType === "Executive" && (
//                   <Select label="Allocate Manager" value={form.managerId} onChange={(v) => updateField("managerId", v)} options={managers.map(m => ({ label: m.name, value: m.id }))} required />
//                 )}
//                 <Input label="Password" type="password" value={form.password} onChange={(v) => updateField("password", v)} required />
//                 <Input label="Confirm Password" type="password" value={form.confirmPassword} onChange={(v) => updateField("confirmPassword", v)} required />
//               </div>

//               <h4 style={{ marginTop: 20, color: "var(--primary)" }}>Assign Permissions</h4>
//               <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 10, }}>
//                 {sidebarComponents.map((p) => (
//                   <label key={p} style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                     <input type="checkbox" checked={form.permissions.includes(p)} onChange={() => togglePermission(p)} />
//                     {p}
//                   </label>
//                 ))}
//               </div>
//               <button type="submit" style={{ marginTop: 20, width: "100%", background: "#02adf0", color: "white", padding: "12px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 16, fontWeight: "bold", }}>
//                 {editUser ? "Update User" : "Save User"}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// /* Reusable Components */
// const Input = ({ label, type = "text", value, onChange, required }) => (
//   <div style={{ display: "flex", flexDirection: "column" }}>
//     <label>{label}</label>
//     <input type={type} required={required} value={value} onChange={(e) => onChange(e.target.value)} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14, }} />
//   </div>
// );

// const Select = ({ label, value, onChange, options }) => (
//   <div style={{ display: "flex", flexDirection: "column" }}>
//     <label>{label}</label>
//     <select value={value} onChange={(e) => onChange(e.target.value)} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14, }}>
//       <option value="">Select</option>
//       {options.map((o) =>
//         typeof o === "string" ? (
//           <option key={o} value={o}>{o}</option>
//         ) : (
//           <option key={o.value} value={o.value}>{o.label}</option>
//         )
//       )}
//     </select>
//   </div>
// );

// export default UserRoles;

// import React, { useState, useMemo, useEffect } from 'react';
// import { 
//   Plus, 
//   Search, 
//   Shield, 
//   Edit, 
//   Trash2,
//   Check,
//   X,
//   Users,
//   Eye,
//   ChevronLeft,
//   ChevronRight,
//   UserCheck
// } from 'lucide-react';

// // Grouped Permissions Blueprint
// const permissionsList = [
//   { id: 'dashboard', name: 'Dashboard', description: 'Access to system monitoring widgets' },
//   { id: 'lead_mgmt', name: 'Lead Management', description: 'Track pipeline targets and source values' },
//   { id: 'crm', name: 'Customer Management (CRM)', description: 'Maintain profile accounts data' },
//   { id: 'cat_master', name: 'Category Master', description: 'Configure dynamic nested catalogs' },
//   { id: 'prod_master', name: 'Product Master', description: 'Manage skus and variant records' },
//   { id: 'inv_master', name: 'Inventory Master', description: 'Monitor stock balance locations' },
//   { id: 'gst_master', name: 'Master GST', description: 'Adjust state and global tax slabs' },
//   { id: 'sales_order', name: 'Sales Order Management', description: 'Process consumer purchase actions' },
//   { id: 'quotation_invoice', name: 'Quotation & Invoicing', description: 'Draft billing estimations' },
//   { id: 'reminders', name: 'Follow-ups & Reminders', description: 'Automate customer checkins' },
//   { id: 'analytics', name: 'Reports & Analytics', description: 'Generate charts and sheets summaries' },
//   { id: 'roles_perms', name: 'User Roles & Permissions', description: 'Administer identity policies' }
// ];

// const initialRoles = [
//   {
//     id: 'admin',
//     name: 'Administrator',
//     description: 'Full system access with all permissions',
//     users: 3,
//     color: 'admin',
//     permissions: permissionsList.map(p => p.id)
//   },
//   {
//     id: 'manager',
//     name: 'Manager',
//     description: 'Manage sales, customers, and view reports',
//     users: 8,
//     color: 'manager',
//     permissions: ['dashboard', 'lead_mgmt', 'crm', 'sales_order', 'quotation_invoice', 'analytics']
//   },
//   {
//     id: 'executive',
//     name: 'Executive',
//     description: 'Operational processing workflows',
//     users: 15,
//     color: 'executive',
//     permissions: ['dashboard', 'lead_mgmt', 'reminders']
//   }
// ];

// const initialUsers = [
//   { id: 1, name: 'John Doe', email: 'john@cloudconnect.com', mobile: '9876543210', gender: 'Male', userType: 'Manager', status: 'Active', permissions: ['dashboard', 'crm'] },
//   { id: 2, name: 'Sarah Miller', email: 'sarah@cloudconnect.com', mobile: '9876543211', gender: 'Female', userType: 'Manager', status: 'Active', permissions: ['dashboard', 'lead_mgmt', 'crm'] },
//   { id: 3, name: 'Mike Chen', email: 'mike@cloudconnect.com', mobile: '9876543212', gender: 'Male', userType: 'Executive', status: 'Active', permissions: ['dashboard', 'reminders'] },
//   { id: 4, name: 'Emily White', email: 'emily@cloudconnect.com', mobile: '9876543213', gender: 'Female', userType: 'Executive', status: 'Active', permissions: ['sales_order', 'quotation_invoice'] },
//   { id: 5, name: 'Tom Wilson', email: 'tom@cloudconnect.com', mobile: '9876543214', gender: 'Other', userType: 'Executive', status: 'Inactive', permissions: ['dashboard'] }
// ];

// const USERS_PER_PAGE = 4;

// // export function UserRolesScreen() {

// const UserRoles = () => {
//   const [roles, setRoles] = useState(initialRoles);
//   const [users, setUsers] = useState(initialUsers);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedRole, setSelectedRole] = useState(initialRoles[0]);
//   const [activeTab, setActiveTab] = useState('users');

//   // --- Modal Form States ---
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingUserId, setEditingUserId] = useState(null);
//   const [viewOnlyMode, setViewOnlyMode] = useState(false);

//   const [formName, setFormName] = useState('');
//   const [formEmail, setFormEmail] = useState('');
//   const [formMobile, setFormMobile] = useState('');
//   const [formGender, setFormGender] = useState('');
//   const [formUserType, setFormUserType] = useState('');
//   const [formPassword, setFormPassword] = useState('');
//   const [formConfirmPassword, setFormConfirmPassword] = useState('');
//   const [formPermissions, setFormPermissions] = useState([]);
//   const [formStatus, setFormStatus] = useState('Active');
//   const [formError, setFormError] = useState('');

//   // --- User Tab Pagination States ---
//   const [userPage, setUserPage] = useState(1);

//   // --- Responsive Media State Monitor via JS Hooks ---
//   const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const isMobile = windowWidth < 640;
//   const isTablet = windowWidth < 768;
//   const isLarge = windowWidth >= 1024;

//   // --- Filter and Search Analytics ---
//   const filteredUsers = useMemo(() => {
//     return users.filter(user => 
//       user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.mobile.includes(searchTerm) ||
//       user.userType.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }, [users, searchTerm]);

//   const totalUserPages = Math.ceil(filteredUsers.length / USERS_PER_PAGE) || 1;
  
//   const displayedUsers = useMemo(() => {
//     const start = (userPage - 1) * USERS_PER_PAGE;
//     return filteredUsers.slice(start, start + USERS_PER_PAGE);
//   }, [filteredUsers, userPage]);

//   // --- Modal Utilities ---
//   const openAddUserModal = () => {
//     setEditingUserId(null);
//     setViewOnlyMode(false);
//     setFormName('');
//     setFormEmail('');
//     setFormMobile('');
//     setFormGender('');
//     setFormUserType('');
//     setFormPassword('');
//     setFormConfirmPassword('');
//     setFormPermissions([]);
//     setFormStatus('Active');
//     setFormError('');
//     setIsModalOpen(true);
//   };

//   const openEditUserModal = (user, viewOnly = false) => {
//     setEditingUserId(user.id);
//     setViewOnlyMode(viewOnly);
//     setFormName(user.name);
//     setFormEmail(user.email);
//     setFormMobile(user.mobile);
//     setFormGender(user.gender);
//     setFormUserType(user.userType);
//     setFormPassword('');
//     setFormConfirmPassword('');
//     setFormPermissions(user.permissions);
//     setFormStatus(user.status);
//     setFormError('');
//     setIsModalOpen(true);
//   };

//   // --- Role Configurator Interactive Updates ---
//   const handleToggleRolePermission = (roleId, permId) => {
//     setRoles(prevRoles => prevRoles.map(role => {
//       if (role.id === roleId) {
//         const alreadyHas = role.permissions.includes(permId);
//         const updatedPerms = alreadyHas 
//           ? role.permissions.filter(id => id !== permId)
//           : [...role.permissions, permId];
        
//         const newRole = { ...role, permissions: updatedPerms };
//         if (selectedRole?.id === roleId) {
//           setSelectedRole(newRole);
//         }
//         return newRole;
//       }
//       return role;
//     }));
//   };

//   // --- Form Modal Permission Update ---
//   const handleToggleFormPermission = (permId) => {
//     if (viewOnlyMode) return;
//     setFormPermissions(prev => 
//       prev.includes(permId) ? prev.filter(id => id !== permId) : [...prev, permId]
//     );
//   };

//   // --- CRUD operations ---
//   const handleSaveUserSubmit = (e) => {
//     e.preventDefault();
//     if (viewOnlyMode) return;
//     setFormError('');

//     if (!formName.trim() || !formEmail.trim() || !formMobile.trim() || !formGender || !formUserType) {
//       setFormError('Please populate all structural mandatory profile values.');
//       return;
//     }

//     if (!editingUserId) {
//       if (!formPassword) {
//         setFormError('Authentication security requires a secure password assignment.');
//         return;
//       }
//       if (formPassword !== formConfirmPassword) {
//         setFormError('Identity confirm verification mismatch.');
//         return;
//       }
//     }

//     if (editingUserId) {
//       setUsers(prev => prev.map(u => u.id === editingUserId ? {
//         ...u,
//         name: formName.trim(),
//         email: formEmail.trim(),
//         mobile: formMobile.trim(),
//         gender: formGender,
//         userType: formUserType,
//         status: formStatus,
//         permissions: formPermissions
//       } : u));
//     } else {
//       const newUser = {
//         id: Date.now(),
//         name: formName.trim(),
//         email: formEmail.trim(),
//         mobile: formMobile.trim(),
//         gender: formGender,
//         userType: formUserType,
//         status: 'Active',
//         permissions: formPermissions
//       };
//       setUsers(prev => [...prev, newUser]);
//       setUserPage(Math.ceil((users.length + 1) / USERS_PER_PAGE));
//     }

//     setIsModalOpen(false);
//   };

//   const handleDeleteUser = (userId) => {
//     const totalRemaining = users.length - 1;
//     const maxPagesNow = Math.ceil(totalRemaining / USERS_PER_PAGE) || 1;
//     if (userPage > maxPagesNow) {
//       setUserPage(maxPagesNow);
//     }
//     setUsers(prev => prev.filter(u => u.id !== userId));
//   };

//   // --- Centralized Palette and Token Variable Storage ---
//   const colors = {
//     bgMain: '#f9fafb',
//     textMain: '#1f2937',
//     textDark: '#111827',
//     textMuted: '#6b7280',
//     borderLight: '#e5e7eb',
//     indigoPrimary: '#4f46e5',
//     indigoHover: '#4338ca',
//     indigoBg: '#f5f3ff',
//     indigoBorder: '#e0e7ff',
//     white: '#ffffff',
//     cardShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'
//   };

//   const getRoleBadgeStyle = (colorType) => {
//     switch(colorType) {
//       case 'admin': return { backgroundColor: '#fef2f2', color: '#b91c1c', borderColor: '#fca5a5' };
//       case 'manager': return { backgroundColor: '#eff6ff', color: '#1d4ed8', borderColor: '#93c5fd' };
//       default: return { backgroundColor: '#f0fdf4', color: '#15803d', borderColor: '#86efac' };
//     }
//   };

//   return (
//     <div style={{
//       padding: isLarge ? '2rem' : '1rem',
//       maxWidth: '80rem',
//       marginLeft: 'auto',
//       marginRight: 'auto',
//       minHeight: '100vh',
//       backgroundColor: colors.bgMain,
//       color: colors.textMain,
//       fontFamily: 'system-ui, -apple-system, sans-serif',
//       boxSizing: 'border-box'
//     }}>
      
//       {/* HEADER SECTION */}
//       <div style={{
//         display: 'flex',
//         flexDirection: isMobile ? 'column' : 'row',
//         alignItems: isMobile ? 'flex-start' : 'center',
//         justifyContent: 'space-between',
//         gap: '1rem',
//         borderBottom: `1px solid ${colors.borderLight}`,
//         paddingBottom: '1.25rem',
//         marginBottom: '1.5rem'
//       }}>
//         <div>
//           <h1 style={{
//             fontSize: isMobile ? '1.25rem' : '1.5rem',
//             fontWeight: '700',
//             letterSpacing: '-0.025em',
//             color: colors.textDark,
//             display: 'flex',
//             alignItems: 'center',
//             gap: '0.625rem',
//             margin: 0
//           }}>
//             <div style={{
//               padding: '0.5rem',
//               backgroundColor: colors.indigoBg,
//               borderRadius: '0.75rem',
//               border: `1px solid ${colors.indigoBorder}`,
//               display: 'flex',
//               alignItems: 'center'
//             }}>
//               <UserCheck style={{ width: isMobile ? '1.25rem' : '1.5rem', height: isMobile ? '1.25rem' : '1.5rem', color: colors.indigoPrimary }} />
//             </div>
//             Access Matrix Control
//           </h1>
//           <p style={{ fontSize: isMobile ? '0.75rem' : '0.875rem', color: colors.textMuted, marginTop: '0.25rem', paddingLeft: '0.25rem', marginBottom: 0 }}>
//             Configure user accounts and manage permission policies across administrative boundaries.
//           </p>
//         </div>
//         <button 
//           onClick={openAddUserModal}
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: '0.5rem',
//             padding: '0.5rem 1rem',
//             backgroundColor: colors.indigoPrimary,
//             color: colors.white,
//             borderRadius: '0.75rem',
//             border: 'none',
//             cursor: 'pointer',
//             fontSize: '0.875rem',
//             fontWeight: '500',
//             width: isMobile ? '100%' : 'auto',
//             justifyContent: 'center',
//             boxShadow: '0 1px 2px 0 rgba(79, 70, 229, 0.05)',
//             transition: 'all 0.2s'
//           }}
//         >
//           <Plus style={{ width: '1rem', height: '1rem' }} />
//           <span>Add New User</span>
//         </button>
//       </div>

//       {/* SEGMENTATION SELECTION TABS */}
//       <div style={{
//         backgroundColor: '#e5e7eb',
//         borderRadius: '0.75rem',
//         padding: '0.25rem',
//         display: 'inline-flex',
//         gap: '0.25rem',
//         marginBottom: '1.5rem'
//       }}>
//         <button
//           onClick={() => { setActiveTab('users'); setSearchTerm(''); }}
//           style={{
//             padding: '0.375rem 1rem',
//             borderRadius: '0.5rem',
//             fontSize: isMobile ? '0.75rem' : '0.875rem',
//             fontWeight: '500',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.2s',
//             backgroundColor: activeTab === 'users' ? colors.white : 'transparent',
//             color: activeTab === 'users' ? colors.textDark : colors.textMuted,
//             boxShadow: activeTab === 'users' ? colors.cardShadow : 'none'
//           }}
//         >
//           Users Directory
//         </button>
//         <button
//           onClick={() => { setActiveTab('roles'); setSearchTerm(''); }}
//           style={{
//             padding: '0.375rem 1rem',
//             borderRadius: '0.5rem',
//             fontSize: isMobile ? '0.75rem' : '0.875rem',
//             fontWeight: '500',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.2s',
//             backgroundColor: activeTab === 'roles' ? colors.white : 'transparent',
//             color: activeTab === 'roles' ? colors.textDark : colors.textMuted,
//             boxShadow: activeTab === 'roles' ? colors.cardShadow : 'none'
//           }}
//         >
//           Roles & Policies
//         </button>
//       </div>

//       {/* ROLES CONFIGURATOR GRAPHICS VIEW */}
//       {activeTab === 'roles' ? (
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: isLarge ? '1fr 2fr' : '1fr',
//           gap: '1.5rem',
//           alignItems: 'flex-start'
//         }}>
          
//           {/* LEFT: ROLES ROW LIST SELECTOR */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//             <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
//               <Search style={{ position: 'absolute', left: '0.75rem', width: '1rem', height: '1rem', color: '#9ca3af' }} />
//               <input
//                 type="text"
//                 placeholder="Search functional roles..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 style={{
//                   width: '100%',
//                   padding: '0.5rem 1rem 0.5rem 2.25rem',
//                   backgroundColor: colors.white,
//                   fontSize: '0.875rem',
//                   border: `1px solid ${colors.borderLight}`,
//                   borderRadius: '0.75rem',
//                   outline: 'none',
//                   boxSizing: 'border-box'
//                 }}
//               />
//             </div>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//               {roles.filter(r => r.name.toLowerCase().includes(searchTerm.toLowerCase())).map((role) => (
//                 <div
//                   key={role.id}
//                   onClick={() => setSelectedRole(role)}
//                   style={{
//                     backgroundColor: colors.white,
//                     border: `1px solid ${selectedRole?.id === role.id ? colors.indigoPrimary : colors.borderLight}`,
//                     borderRadius: '0.75rem',
//                     padding: '1rem',
//                     cursor: 'pointer',
//                     transition: 'all 0.2s',
//                     boxShadow: selectedRole?.id === role.id ? '0 0 0 4px rgba(79, 70, 229, 0.1)' : 'none'
//                   }}
//                 >
//                   <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
//                     <div style={{
//                       padding: '0.5rem',
//                       backgroundColor: colors.indigoBg,
//                       border: `1px solid ${colors.indigoBorder}`,
//                       borderRadius: '0.5rem',
//                       display: 'flex'
//                     }}>
//                       <Shield style={{ width: '1rem', height: '1rem', color: colors.indigoPrimary }} />
//                     </div>
//                     <div style={{ flex: 1, minWidth: 0 }}>
//                       <h3 style={{ fontSize: '0.875rem', fontWeight: '600', color: colors.textDark, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{role.name}</h3>
//                       <p style={{ color: colors.textMuted, fontSize: '0.75rem', marginTop: '0.125rem', marginBottom: 0, display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{role.description}</p>
//                     </div>
//                   </div>
//                   <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     marginTop: '0.75rem',
//                     paddingTop: '0.75rem',
//                     borderTop: `1px solid ${colors.borderLight}`,
//                     fontSize: '0.75rem'
//                   }}>
//                     <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', color: colors.textMuted, fontWeight: '500' }}>
//                       <Users style={{ width: '0.875rem', height: '0.875rem' }} /> {role.users} Accounts
//                     </span>
//                     <span style={{
//                       padding: '0.125rem 0.5rem',
//                       borderRadius: '9999px',
//                       fontWeight: '500',
//                       border: '1px solid transparent',
//                       ...getRoleBadgeStyle(role.color)
//                     }}>
//                       {role.permissions.length} Keys
//                     </span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* RIGHT: POLICY ADJUSTMENT CONTAINER */}
//           <div>
//             {selectedRole ? (
//               <div style={{
//                 backgroundColor: colors.white,
//                 border: `1px solid ${colors.borderLight}`,
//                 borderRadius: '1rem',
//                 padding: isMobile ? '1.25rem' : '1.5rem',
//                 boxShadow: colors.cardShadow
//               }}>
//                 <div style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '0.75rem',
//                   borderBottom: `1px solid ${colors.borderLight}`,
//                   paddingBottom: '1rem',
//                   marginBottom: '1.25rem'
//                 }}>
//                   <div style={{ padding: '0.625rem', backgroundColor: colors.indigoBg, border: `1px solid ${colors.indigoBorder}`, borderRadius: '0.75rem', display: 'flex' }}>
//                     <Shield style={{ width: '1.25rem', height: '1.25rem', color: colors.indigoPrimary }} />
//                   </div>
//                   <div>
//                     <h2 style={{ fontSize: isMobile ? '1rem' : '1.125rem', fontWeight: '700', color: colors.textDark, margin: 0 }}>{selectedRole.name} Matrix</h2>
//                     <p style={{ color: colors.textMuted, fontSize: isMobile ? '0.75rem' : '0.875rem', marginTop: '0.125rem', marginBottom: 0 }}>{selectedRole.description}</p>
//                   </div>
//                 </div>

//                 <div>
//                   <h3 style={{ fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#9ca3af', marginBottom: '0.75rem', margin: 0 }}>Policy Nodes Assignment</h3>
//                   <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//                     gap: '0.75rem',
//                     maxHeight: '500px',
//                     overflowY: 'auto',
//                     paddingRight: '0.25rem'
//                   }}>
//                     {permissionsList.map((permission) => {
//                       const hasPermission = selectedRole.permissions.includes(permission.id);
//                       return (
//                         <div
//                           key={permission.id}
//                           style={{
//                             display: 'flex',
//                             itemsAlign: 'flex-start',
//                             justifyContent: 'space-between',
//                             padding: '0.75rem',
//                             borderRadius: '0.75rem',
//                             border: `1px solid ${hasPermission ? '#c7d2fe' : colors.borderLight}`,
//                             backgroundColor: hasPermission ? 'rgba(245, 243, 255, 0.4)' : 'rgba(249, 250, 251, 0.5)',
//                             transition: 'all 0.2s',
//                             boxSizing: 'border-box'
//                           }}
//                         >
//                           <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.625rem', minWidth: 0, flex: 1 }}>
//                             <div style={{ marginTop: '0.125rem', flexShrink: 0, color: hasPermission ? colors.indigoPrimary : '#d1d5db' }}>
//                               {hasPermission ? <Check style={{ width: '1rem', height: '1rem', strokeWidth: '2.5' }} /> : <X style={{ width: '1rem', height: '1rem' }} />}
//                             </div>
//                             <div style={{ minWidth: 0 }}>
//                               <p style={{ fontSize: '0.75rem', fontWeight: '600', margin: 0, color: hasPermission ? colors.textDark : colors.textMuted }}>
//                                 {permission.name}
//                               </p>
//                               <p style={{ fontSize: '10px', color: colors.textMuted, marginTop: '0.125rem', marginBottom: 0, display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{permission.description}</p>
//                             </div>
//                           </div>
                          
//                           <label style={{ position: 'relative', inlineFlex: 'center', display: 'flex', alignItems: 'center', cursor: 'pointer', flexShrink: 0, marginLeft: '0.5rem' }}>
//                             <input
//                               type="checkbox"
//                               checked={hasPermission}
//                               onChange={() => handleToggleRolePermission(selectedRole.id, permission.id)}
//                               style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', border: 0 }}
//                             />
//                             <div style={{
//                               width: '2rem',
//                               height: '1.125rem',
//                               backgroundColor: hasPermission ? colors.indigoPrimary : '#d1d5db',
//                               borderRadius: '9999px',
//                               position: 'relative',
//                               transition: 'all 0.2s'
//                             }}>
//                               <div style={{
//                                 width: '0.875rem',
//                                 height: '0.875rem',
//                                 backgroundColor: colors.white,
//                                 borderRadius: '50%',
//                                 position: 'absolute',
//                                 top: '2px',
//                                 left: hasPermission ? '16px' : '2px',
//                                 transition: 'all 0.2s'
//                               }} />
//                             </div>
//                           </label>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <div style={{ backgroundColor: colors.white, border: `1px solid ${colors.borderLight}`, borderRadius: '1rem', padding: '3rem', textAlign: 'center', color: colors.textMuted }}>
//                 <Shield style={{ width: '2rem', height: '2rem', marginLeft: 'auto', marginRight: 'auto', marginBottom: '0.5rem', color: '#d1d5db' }} />
//                 Select a profile node target role block to edit its active permissions.
//               </div>
//             )}
//           </div>
//         </div>
//       ) : (
        
//         /* USERS ACCOUNT WORKSPACE DIRECTORY TAB */
//         <div style={{
//           backgroundColor: colors.white,
//           border: `1px solid ${colors.borderLight}`,
//           borderRadius: '1rem',
//           padding: isLarge ? '1.5rem' : '1rem',
//           boxShadow: colors.cardShadow
//         }}>
//           <div style={{ position: 'relative', maxWidth: '28rem', marginBottom: '1.25rem', display: 'flex', alignItems: 'center' }}>
//             <Search style={{ position: 'absolute', left: '0.75rem', width: '1rem', height: '1rem', color: '#9ca3af' }} />
//             <input
//               type="text"
//               placeholder="Filter names, emails, mobile or roles..."
//               value={searchTerm}
//               onChange={(e) => { setSearchTerm(e.target.value); setUserPage(1); }}
//               style={{
//                 width: '100%',
//                 padding: '0.5rem 1rem 0.5rem 2.25rem',
//                 backgroundColor: '#f9fafb',
//                 border: `1px solid ${colors.borderLight}`,
//                 fontSize: '0.875rem',
//                 borderRadius: '0.75rem',
//                 outline: 'none',
//                 boxSizing: 'border-box'
//               }}
//             />
//           </div>

//           {/* DESKTOP TABLE VIEW */}
//           {!isTablet && (
//             <div style={{ overflow: 'hidden', borderRadius: '0.75rem', border: `1px solid ${colors.borderLight}` }}>
//               <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.875rem' }}>
//                 <thead>
//                   <tr style={{ borderBottom: `1px solid ${colors.borderLight}`, backgroundColor: 'rgba(249, 250, 251, 0.7)', fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: colors.textMuted }}>
//                     <th style={{ padding: '0.875rem 1rem' }}>User Meta profile</th>
//                     <th style={{ padding: '0.875rem 1rem' }}>Contact Link</th>
//                     <th style={{ padding: '0.875rem 1rem' }}>Type Allocation</th>
//                     <th style={{ padding: '0.875rem 1rem' }}>Status</th>
//                     <th style={{ padding: '0.875rem 1rem', textAlign: 'right' }}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody style={{ backgroundColor: colors.white }}>
//                   {displayedUsers.length === 0 ? (
//                     <tr>
//                       <td colSpan={5} style={{ padding: '3rem', textAlign: 'center', fontSize: '0.875rem', fontStyle: 'italic', color: colors.textMuted }}>
//                         No matching personnel items discovered in local storage arrays.
//                       </td>
//                     </tr>
//                   ) : (
//                     displayedUsers.map((user) => (
//                       <tr key={user.id} style={{ borderBottom: `1px solid ${colors.borderLight}`, transition: 'background-color 0.2s' }}>
//                         <td style={{ padding: '0.875rem 1rem' }}>
//                           <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
//                             <div style={{
//                               width: '2.25rem',
//                               height: '2.25rem',
//                               backgroundColor: colors.indigoBg,
//                               border: `1px solid ${colors.indigoBorder}`,
//                               borderRadius: '50%',
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               fontWeight: '700',
//                               color: colors.indigoPrimary,
//                               fontSize: '0.75rem',
//                               flexShrink: 0
//                             }}>
//                               {user.name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()}
//                             </div>
//                             <div>
//                               <span style={{ fontWeight: '600', color: colors.textDark, display: 'block' }}>{user.name}</span>
//                               <span style={{ fontSize: '10px', color: colors.textMuted, fontFamily: 'monospace' }}>{user.gender}</span>
//                             </div>
//                           </div>
//                         </td>
//                         <td style={{ padding: '0.875rem 1rem' }}>
//                           <span style={{ color: '#374151', display: 'block', fontSize: '0.75rem', fontWeight: '500' }}>{user.email}</span>
//                           <span style={{ color: colors.textMuted, display: 'block', fontSize: '11px', marginTop: '0.125rem' }}>{user.mobile}</span>
//                         </td>
//                         <td style={{ padding: '0.875rem 1rem' }}>
//                           <span style={{
//                             padding: '0.125rem 0.625rem',
//                             borderRadius: '9999px',
//                             fontSize: '0.75rem',
//                             fontWeight: '600',
//                             border: '1px solid',
//                             ...(user.userType === 'Manager' ? { backgroundColor: '#eff6ff', color: '#1d4ed8', borderColor: '#dbeafe' } : { backgroundColor: '#f0fdf4', color: '#15803d', borderColor: '#dcfce7' })
//                           }}>
//                             {user.userType}
//                           </span>
//                         </td>
//                         <td style={{ padding: '0.875rem 1rem' }}>
//                           <span style={{
//                             display: 'inline-flex',
//                             alignItems: 'center',
//                             gap: '0.25rem',
//                             padding: '0.125rem 0.5rem',
//                             borderRadius: '9999px',
//                             fontSize: '0.75rem',
//                             fontWeight: '500',
//                             ...(user.status === 'Active' ? { backgroundColor: '#ecfdf5', color: '#047857' } : { backgroundColor: '#f3f4f6', color: '#374151' })
//                           }}>
//                             <span style={{ width: '0.375rem', height: '0.375rem', borderRadius: '50%', backgroundColor: user.status === 'Active' ? '#10b981' : '#9ca3af' }} />
//                             {user.status}
//                           </span>
//                         </td>
//                         <td style={{ padding: '0.875rem 1rem', textAlign: 'right' }}>
//                           <div style={{ display: 'flex', gap: '0.125rem', justifyContent: 'flex-end' }}>
//                             <button onClick={() => openEditUserModal(user, true)} title="View Permissions Map" style={{ padding: '0.375rem', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', borderRadius: '0.5rem' }}>
//                               <Eye style={{ width: '1rem', height: '1rem' }} />
//                             </button>
//                             <button onClick={() => openEditUserModal(user, false)} title="Modify User Records" style={{ padding: '0.375rem', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', borderRadius: '0.5rem' }}>
//                               <Edit style={{ width: '1rem', height: '1rem' }} />
//                             </button>
//                             <button onClick={() => handleDeleteUser(user.id)} title="Purge Record" style={{ padding: '0.375rem', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', borderRadius: '0.5rem' }}>
//                               <Trash2 style={{ width: '1rem', height: '1rem' }} />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}

//           {/* MOBILE CARD VIEW */}
//           {isTablet && (
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//               {displayedUsers.length === 0 ? (
//                 <div style={{ padding: '3rem', textAlign: 'center', fontSize: '0.875rem', fontStyle: 'italic', color: colors.textMuted, border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem' }}>
//                   No matching personnel items discovered in local storage arrays.
//                 </div>
//               ) : (
//                 displayedUsers.map((user) => (
//                   <div key={user.id} style={{ padding: '1rem', backgroundColor: colors.white, border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' }}>
//                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                       <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}>
//                         <div style={{
//                           width: '2.25rem',
//                           height: '2.25rem',
//                           backgroundColor: colors.indigoBg,
//                           border: `1px solid ${colors.indigoBorder}`,
//                           borderRadius: '50%',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           fontWeight: '700',
//                           color: colors.indigoPrimary,
//                           fontSize: '0.75rem',
//                           flexShrink: 0
//                         }}>
//                           {user.name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()}
//                         </div>
//                         <div>
//                           <span style={{ fontWeight: '600', color: colors.textDark, display: 'block', fontSize: '0.875rem' }}>{user.name}</span>
//                           <span style={{ fontSize: '10px', color: colors.textMuted, fontFamily: 'monospace' }}>{user.gender}</span>
//                         </div>
//                       </div>
                      
//                       <span style={{
//                         display: 'inline-flex',
//                         alignItems: 'center',
//                         gap: '0.25rem',
//                         padding: '0.125rem 0.5rem',
//                         borderRadius: '9999px',
//                         fontSize: '0.75rem',
//                         fontWeight: '500',
//                         ...(user.status === 'Active' ? { backgroundColor: '#ecfdf5', color: '#047857' } : { backgroundColor: '#f3f4f6', color: '#374151' })
//                       }}>
//                         <span style={{ width: '0.375rem', height: '0.375rem', borderRadius: '50%', backgroundColor: user.status === 'Active' ? '#10b981' : '#9ca3af' }} />
//                         {user.status}
//                       </span>
//                     </div>

//                     <hr style={{ border: 0, borderTop: `1px solid ${colors.borderLight}`, margin: 0 }} />

//                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', fontSize: '0.75rem' }}>
//                       <div>
//                         <span style={{ color: colors.textMuted, display: 'block', marginBottom: '0.125rem' }}>Contact Link</span>
//                         <span style={{ color: '#374151', fontWeight: '500', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user.email}</span>
//                         <span style={{ color: '#6b7280', display: 'block', marginTop: '0.125rem' }}>{user.mobile}</span>
//                       </div>
//                       <div>
//                         <span style={{ color: colors.textMuted, display: 'block', marginBottom: '0.25rem' }}>Type Allocation</span>
//                         <span style={{
//                           padding: '0.125rem 0.5rem',
//                           borderRadius: '9999px',
//                           fontSize: '0.75rem',
//                           fontWeight: '600',
//                           border: '1px solid',
//                           display: 'inline-block',
//                           ...(user.userType === 'Manager' ? { backgroundColor: '#eff6ff', color: '#1d4ed8', borderColor: '#dbeafe' } : { backgroundColor: '#f0fdf4', color: '#15803d', borderColor: '#dcfce7' })
//                         }}>
//                           {user.userType}
//                         </span>
//                       </div>
//                     </div>

//                     <hr style={{ border: 0, borderTop: `1px solid ${colors.borderLight}`, margin: 0 }} />

//                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '0.5rem', paddingTop: '0.25rem' }}>
//                       <button onClick={() => openEditUserModal(user, true)} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.625rem', fontSize: '0.75rem', color: '#374151', backgroundColor: '#f3f4f6', border: 'none', borderRadius: '0.5rem', cursor: 'pointer' }}>
//                         <Eye style={{ width: '0.875rem', height: '0.875rem' }} /> View
//                       </button>
//                       <button onClick={() => openEditUserModal(user, false)} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.625rem', fontSize: '0.75rem', color: colors.indigoPrimary, backgroundColor: colors.indigoBg, border: 'none', borderRadius: '0.5rem', cursor: 'pointer' }}>
//                         <Edit style={{ width: '0.875rem', height: '0.875rem' }} /> Edit
//                       </button>
//                       <button onClick={() => handleDeleteUser(user.id)} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.625rem', fontSize: '0.75rem', color: '#b91c1c', backgroundColor: '#fef2f2', border: 'none', borderRadius: '0.5rem', cursor: 'pointer' }}>
//                         <Trash2 style={{ width: '0.875rem', height: '0.875rem' }} /> Delete
//                       </button>
//                     </div>
//                   </div>
//                 ))
//               )}
//             </div>
//           )}

//           {/* TABLE PAGINATION FOOTER */}
//           {filteredUsers.length > 0 && (
//             <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '0.75rem', alignItems: 'center', justifyContent: 'space-between', marginTop: '1.25rem', paddingLeft: '0.25rem', fontSize: '0.75rem', fontWeight: '500', color: colors.textMuted }}>
//               <span>Showing <strong>{displayedUsers.length}</strong> of {filteredUsers.length} entries</span>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                 <span style={{ color: '#9ca3af' }}>Page {userPage} of {totalUserPages}</span>
//                 <div style={{ display: 'flex', gap: '0.25rem' }}>
//                   <button 
//                     disabled={userPage === 1}
//                     onClick={() => setUserPage(p => Math.max(p - 1, 1))}
//                     style={{ padding: '0.375rem', backgroundColor: colors.white, border: `1px solid ${colors.borderLight}`, borderRadius: '0.5rem', color: '#374151', cursor: userPage === 1 ? 'not-allowed' : 'pointer', opacity: userPage === 1 ? 0.4 : 1, display: 'flex' }}
//                   >
//                     <ChevronLeft style={{ width: '1rem', height: '1rem' }} />
//                   </button>
//                   <button 
//                     disabled={userPage === totalUserPages}
//                     onClick={() => setUserPage(p => Math.min(p + 1, totalUserPages))}
//                     style={{ padding: '0.375rem', backgroundColor: colors.white, border: `1px solid ${colors.borderLight}`, borderRadius: '0.5rem', color: '#374151', cursor: userPage === totalUserPages ? 'not-allowed' : 'pointer', opacity: userPage === totalUserPages ? 0.4 : 1, display: 'flex' }}
//                   >
//                     <ChevronRight style={{ width: '1rem', height: '1rem' }} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* MODAL SLIDEOVER DRAWER BACKDROP */}
//       {isModalOpen && (
//         <div style={{
//           position: 'fixed',
//           top: 0, left: 0, right: 0, bottom: 0,
//           zIndex: 50,
//           backgroundColor: 'rgba(17, 24, 39, 0.4)',
//           backdropFilter: 'blur(4px)',
//           display: 'flex',
//           justifyContent: isMobile ? 'center' : 'flex-end',
//           overflowY: 'auto'
//         }}>
//           <form 
//             onSubmit={handleSaveUserSubmit}
//             style={{
//               backgroundColor: colors.white,
//               width: '100%',
//               maxWidth: '36rem',
//               minHeight: '100vh',
//               display: 'flex',
//               flexDirection: 'column',
//               boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
//               boxSizing: 'border-box'
//             }}
//           >
            
//             {/* MODAL HEADER */}
//             <div style={{ padding: '1.25rem', borderBottom: `1px solid ${colors.borderLight}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#f9fafb' }}>
//               <div>
//                 <h3 style={{ fontSize: '1rem', fontWeight: '700', color: colors.textDark, margin: 0 }}>
//                   {viewOnlyMode ? 'View User Details' : editingUserId ? 'Modify User Profile' : 'Create New Personnel Node'}
//                 </h3>
//                 <p style={{ fontSize: '11px', color: colors.textMuted, marginTop: '0.125rem', margin: 0 }}>
//                   {viewOnlyMode ? 'Read-only access matrix privileges map.' : 'Ensure context fields align securely.'}
//                 </p>
//               </div>
//               <button 
//                 type="button"
//                 onClick={() => setIsModalOpen(false)}
//                 style={{ padding: '0.375rem', background: 'none', border: 'none', cursor: 'pointer', borderRadius: '0.5rem', color: '#9ca3af', display: 'flex' }}
//               >
//                 <X style={{ width: '1.25rem', height: '1.25rem' }} />
//               </button>
//             </div>

//             {/* MODAL BODY CONTROLS */}
//             <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? '1.25rem' : '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem', boxSizing: 'border-box' }}>
//               {formError && (
//                 <div style={{ padding: '0.75rem', backgroundColor: '#fef2f2', border: '1px solid #fca5a5', borderRadius: '0.75rem', fontSize: '0.75rem', fontWeight: '600', color: '#b91c1c' }}>
//                   {formError}
//                 </div>
//               )}

//               <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Full Name *</label>
//                   <input 
//                     type="text" 
//                     disabled={viewOnlyMode}
//                     value={formName}
//                     onChange={(e) => setFormName(e.target.value)}
//                     placeholder="e.g. Alexander Pierce"
//                     style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', backgroundColor: viewOnlyMode ? '#f3f4f6' : colors.white, color: viewOnlyMode ? '#6b7280' : colors.textDark, boxSizing: 'border-box' }}
//                   />
//                 </div>

//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Email Target *</label>
//                   <input 
//                     type="email" 
//                     disabled={viewOnlyMode}
//                     value={formEmail}
//                     onChange={(e) => setFormEmail(e.target.value)}
//                     placeholder="alex@cloudconnect.com"
//                     style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', backgroundColor: viewOnlyMode ? '#f3f4f6' : colors.white, color: viewOnlyMode ? '#6b7280' : colors.textDark, boxSizing: 'border-box' }}
//                   />
//                 </div>
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Mobile Terminal *</label>
//                   <input 
//                     type="tel" 
//                     disabled={viewOnlyMode}
//                     value={formMobile}
//                     onChange={(e) => setFormMobile(e.target.value)}
//                     placeholder="9876543210"
//                     style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', backgroundColor: viewOnlyMode ? '#f3f4f6' : colors.white, color: viewOnlyMode ? '#6b7280' : colors.textDark, boxSizing: 'border-box' }}
//                   />
//                 </div>

//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Gender Identifier *</label>
//                   <select 
//                     disabled={viewOnlyMode}
//                     value={formGender}
//                     onChange={(e) => setFormGender(e.target.value)}
//                     style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', backgroundColor: viewOnlyMode ? '#f3f4f6' : colors.white, color: viewOnlyMode ? '#6b7280' : colors.textDark, boxSizing: 'border-box' }}
//                   >
//                     <option value="">Choose context...</option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                     <option value="Other">Other</option>
//                   </select>
//                 </div>
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Type Allocation *</label>
//                   <select 
//                     disabled={viewOnlyMode}
//                     value={formUserType}
//                     onChange={(e) => setFormUserType(e.target.value)}
//                     style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', backgroundColor: viewOnlyMode ? '#f3f4f6' : colors.white, color: viewOnlyMode ? '#6b7280' : colors.textDark, boxSizing: 'border-box' }}
//                   >
//                     <option value="">Select Role Class...</option>
//                     <option value="Manager">Manager</option>
//                     <option value="Executive">Executive</option>
//                   </select>
//                 </div>

//                 {editingUserId && !viewOnlyMode && (
//                   <div>
//                     <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Operational Status</label>
//                     <select 
//                       value={formStatus}
//                       onChange={(e) => setFormStatus(e.target.value)}
//                       style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', backgroundColor: colors.white, color: colors.textDark, boxSizing: 'border-box' }}
//                     >
//                       <option value="Active">Active Operational</option>
//                       <option value="Inactive">Inactive Suspended</option>
//                     </select>
//                   </div>
//                 )}
//               </div>

//               {!editingUserId && !viewOnlyMode && (
//                 <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem', backgroundColor: '#f9fafb', padding: '1rem', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem' }}>
//                   <div>
//                     <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Pass Key Sequence *</label>
//                     <input 
//                       type="password" 
//                       value={formPassword}
//                       onChange={(e) => setFormPassword(e.target.value)}
//                       placeholder="••••••••"
//                       style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', backgroundColor: colors.white, border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', boxSizing: 'border-box' }}
//                     />
//                   </div>
//                   <div>
//                     <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Confirm Verification *</label>
//                     <input 
//                       type="password" 
//                       value={formConfirmPassword}
//                       onChange={(e) => setFormConfirmPassword(e.target.value)}
//                       placeholder="••••••••"
//                       style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', backgroundColor: colors.white, border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', boxSizing: 'border-box' }}
//                     />
//                   </div>
//                 </div>
//               )}

//               <div>
//                 <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Direct Account Keys Blueprint Override</label>
//                 <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '0.5rem', maxHeight: '15rem', overflowY: 'auto', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', padding: '0.5rem', backgroundColor: 'rgba(249, 250, 251, 0.5)' }}>
//                   {permissionsList.map((perm) => {
//                     const isChecked = formPermissions.includes(perm.id);
//                     return (
//                       <div 
//                         key={perm.id}
//                         onClick={() => handleToggleFormPermission(perm.id)}
//                         style={{
//                           padding: '0.625rem',
//                           border: `1px solid ${isChecked ? '#c7d2fe' : colors.borderLight}`,
//                           borderRadius: '0.5rem',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'space-between',
//                           userSelect: 'none',
//                           cursor: viewOnlyMode ? 'default' : 'pointer',
//                           backgroundColor: isChecked ? 'rgba(245, 243, 255, 0.6)' : colors.white,
//                           color: isChecked ? colors.textDark : colors.textMuted
//                         }}
//                       >
//                         <div style={{ minWidth: 0, paddingRight: '0.25rem' }}>
//                           <p style={{ fontSize: '0.75rem', fontWeight: '600', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{perm.name}</p>
//                         </div>
//                         <div style={{
//                           width: '1rem',
//                           height: '1rem',
//                           borderRadius: '0.25rem',
//                           border: `1px solid ${isChecked ? colors.indigoPrimary : '#d1d5db'}`,
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           flexShrink: 0,
//                           backgroundColor: isChecked ? colors.indigoPrimary : colors.white,
//                           color: colors.white
//                         }}>
//                           {isChecked && <Check style={{ width: '0.75rem', height: '0.75rem', strokeWidth: '3' }} />}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>

//             {/* MODAL BOTTOM FOOTERDRAWER ACTUATORS */}
//             <div style={{ padding: '1rem', borderTop: `1px solid ${colors.borderLight}`, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '0.75rem', backgroundColor: '#f9fafb' }}>
//               <button
//                 type="button"
//                 onClick={() => setIsModalOpen(false)}
//                 style={{ padding: '0.5rem 1rem', fontSize: '0.875rem', fontWeight: '500', border: `1px solid ${colors.borderLight}`, hoverBg: '#f3f4f6', backgroundColor: colors.white, borderRadius: '0.75rem', cursor: 'pointer', color: '#374151' }}
//               >
//                 Close Drawer
//               </button>
//               {!viewOnlyMode && (
//                 <button
//                   type="submit"
//                   style={{ padding: '0.5rem 1.25rem', fontSize: '0.875rem', fontWeight: '500', backgroundColor: colors.indigoPrimary, color: colors.white, border: 'none', borderRadius: '0.75rem', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' }}
//                 >
//                   {editingUserId ? 'Commit Records' : 'Provision Account'}
//                 </button>
//               )}
//             </div>

//           </form>
//         </div>
//       )}
//     </div>
//   );
// }

//  export default UserRoles;


import React, { useState, useEffect } from "react";
import { Plus, Search, Filter, Shield, Edit, Trash2, Check, X, Users, UserCheck } from 'lucide-react';

/* ===== SIDEBAR PERMISSIONS ===== */
const sidebarComponents = [
  "Dashboard",
  "Lead Management",
  "Customer Management (CRM)",
  "Master Management",
  "Category",
  "Product Master",
  "Inventory Master",
  "Master GST",
  "Sales Order Management",
  "Quotation & Invoicing",
  "Follow-ups & Reminders",
  "Reports & Analytics",
  "User Roles & Permissions",
];

const UserRoles = () => {
  // Keep exact original functionality states
  const [users, setUsers] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [managers, setManagers] = useState([]);
  const [searchTerm, setSearchTerm] = useState(''); // Seamless search tracking matching the design

  /* ==== FORM STATES ==== */
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    gender: "",
    userType: "",
    managerId: "",
    password: "",
    confirmPassword: "",
    permissions: [],
  });

  // Track responsive layout dynamically for clean inline presentation blocks
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 640;
  const isTablet = windowWidth < 768;
  const isLarge = windowWidth >= 1024;

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(sessionStorage.getItem("userData"));
      const userId = user?.id;

      if (!userId) throw new Error("User not logged in");

      const res = await fetch(
        `https://cloudapi.emedhatechnologies.com/pages/api/get/users?user_id=${userId}`
      );
      setUsers(await res.json());
    } catch (e) {
      console.error(e);
      alert("Failed to load users.");
    }
    setLoading(false);
  };

  // Fetch managers for logged-in user
  const fetchManagers = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("userData"));
      const userId = user?.id;

      if (!userId) return;

      const res = await fetch(
        `https://cloudapi.emedhatechnologies.com/pages/api/get/managers?user_id=${userId}`
      );

      setManagers(await res.json());
    } catch (err) {
      console.error("Failed to fetch managers", err);
    }
  };

  useEffect(() => {
    if (form.userType === "Executive") {
      fetchManagers();
    }
  }, [form.userType]);

  /* ====== Modal Open for Create ====== */
  const openAddModal = () => {
    setEditUser(null);
    setForm({
      name: "",
      email: "",
      mobile: "",
      gender: "",
      userType: "",
      managerId: "",
      password: "",
      confirmPassword: "",
      permissions: [],
    });
    setModalOpen(true);
  };

  /* ====== Modal Open for Edit ====== */
  const openEditModal = (user) => {
    setEditUser(user);
    setForm({
      name: user.name || "",
      email: user.email,
      mobile: user.mobile || "",
      gender: user.gender || "",
      userType: user.user_type || "",
      managerId: user.manager_id || "",
      password: user.password,
      confirmPassword: user.password,
      permissions: user.permissions || [],
    });
    setModalOpen(true);
  };

  /* ====== Handle Form Fields ====== */
  const updateField = (field, value) =>
    setForm({ ...form, [field]: value });

  const togglePermission = (p) => {
    setForm((prev) => ({
      ...prev,
      permissions: prev.permissions.includes(p)
        ? prev.permissions.filter((x) => x !== p)
        : [...prev.permissions, p],
    }));
  };

  /* ===== SUBMIT ===== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== form.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    const user = JSON.parse(sessionStorage.getItem("userData"));

    const payload = {
      ...form,
      user_type: form.userType,
      manager_id: form.userType === "Executive" ? form.managerId : null,
      user_id: user?.id,
    };

    delete payload.userType;
    delete payload.confirmPassword;

    try {
      let res;

      if (editUser) {
        res = await fetch(
          `https://cloudapi.emedhatechnologies.com/pages/api/update/users/${editUser.id}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        );
      } else {
        res = await fetch("https://cloudapi.emedhatechnologies.com/pages/api/add/users/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      }

      if (!res.ok) throw new Error();

      await fetchUsers();
      setModalOpen(false);
      alert(editUser ? "User updated!" : "User added!");
    } catch (e) {
      console.error(e);
      alert("Failed to save user.");
    }
  };

  /* ===== DELETE USER ===== */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this user?")) return;

    try {
      await fetch(
        `https://cloudapi.emedhatechnologies.com/pages/api/userspermissions/${id}`,
        { method: "DELETE" }
      );

      setUsers((prev) => prev.filter((u) => u.id !== id));
      alert("User deleted.");
    } catch (e) {
      alert("Failed to delete.");
    }
  };

  // Live filter matching search conditions
  const filteredUsers = users.filter(u => 
    (u.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (u.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (u.user_type || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Modern Premium Theme tokens mapping 
  const colors = {
    bgMain: '#f9fafb',
    textMain: '#1f2937',
    textDark: '#111827',
    textMuted: '#6b7280',
    borderLight: '#e5e7eb',
    indigoPrimary: '#4f46e5',
    indigoHover: '#4338ca',
    indigoBg: '#f5f3ff',
    indigoBorder: '#e0e7ff',
    white: '#ffffff',
    cardShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'
  };

  const containerStyle = {
    maxWidth: '80rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    minHeight: '100vh',
    backgroundColor: colors.bgMain,
    color: colors.textMain,
    fontFamily: 'system-ui, -apple-system, sans-serif',
    boxSizing: 'border-box'
  };

  const cardStyle = {
    backgroundColor: colors.white,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: '1rem',
    padding: isLarge ? '1.5rem' : '1rem',
    boxShadow: colors.cardShadow
  };

  return (
    <div style={containerStyle}>
      {/* HEADER SECTION */}
      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        borderBottom: `1px solid ${colors.borderLight}`,
        paddingBottom: '1.25rem',
        marginBottom: '1.5rem'
      }}>
        <div>
          <h1 style={{
            fontSize: isMobile ? '1.25rem' : '1.5rem',
            fontWeight: '700',
            letterSpacing: '-0.025em',
            color: colors.textDark,
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            margin: 0
          }}>
            <div style={{
              padding: '0.5rem',
              backgroundColor: colors.indigoBg,
              borderRadius: '0.75rem',
              border: `1px solid ${colors.indigoBorder}`,
              display: 'flex'
            }}>
              <UserCheck style={{ width: isMobile ? '1.25rem' : '1.5rem', height: isMobile ? '1.25rem' : '1.5rem', color: colors.indigoPrimary }} />
            </div>
            User Roles & Permissions
          </h1>
          <p style={{ fontSize: isMobile ? '0.75rem' : '0.875rem', color: colors.textMuted, marginTop: '0.25rem', paddingLeft: '0.25rem', margin: 0 }}>
            Configure employee matrix parameters and map functional permission overrides.
          </p>
        </div>
        <button 
          onClick={openAddModal}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            backgroundColor: colors.indigoPrimary,
            color: colors.white,
            borderRadius: '0.75rem',
            border: 'none',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: '500',
            width: isMobile ? '100%' : 'auto',
            justifyContent: 'center',
            transition: 'background-color 0.2s'
          }}
        >
          <Plus style={{ width: '1rem', height: '1rem' }} />
          <span>Add User</span>
        </button>
      </div>

      {/* FILTER SEARCH BAR */}
      <div style={{ ...cardStyle, padding: '1rem', marginBottom: '1.5rem' }}>
        <div style={{ position: 'relative', maxWidth: '28rem', display: 'flex', alignItems: 'center' }}>
          <Search style={{ position: 'absolute', left: '0.75rem', width: '1rem', height: '1rem', color: '#9ca3af' }} />
          <input
            type="text"
            placeholder="Search matching accounts by profile meta data..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '0.5rem 1rem 0.5rem 2.25rem',
              backgroundColor: '#f9fafb',
              border: `1px solid ${colors.borderLight}`,
              fontSize: '0.875rem',
              borderRadius: '0.75rem',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />
        </div>
      </div>

      {/* WORKSPACE VIEW PORT */}
      <div style={cardStyle}>
        {loading ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: colors.textMuted, fontStyle: 'italic' }}>Loading dynamic matrix entries...</div>
        ) : filteredUsers.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: colors.textMuted, fontStyle: 'italic' }}>No active user records matching parameters found.</div>
        ) : (
          <>
            {/* DESKTOP MATRIX LIST VIEW */}
            {!isTablet && (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.875rem' }}>
                  <thead>
                    <tr style={{ borderBottom: `1px solid ${colors.borderLight}`, backgroundColor: 'rgba(249, 250, 251, 0.7)', fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', color: colors.textMuted }}>
                      <th style={{ padding: '0.875rem 1rem' }}># ID</th>
                      <th style={{ padding: '0.875rem 1rem' }}>User Meta Profile</th>
                      <th style={{ padding: '0.875rem 1rem' }}>Contact Anchor</th>
                      <th style={{ padding: '0.875rem 1rem' }}>Type Allocation</th>
                      <th style={{ padding: '0.875rem 1rem', textAlign: 'right' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.map((u, index) => (
                      <tr key={u.id} style={{ borderBottom: `1px solid ${colors.borderLight}`, transition: 'background-color 0.2s' }}>
                        <td style={{ padding: '1rem', fontWeight: '600', color: colors.textMuted }}>{index + 1}</td>
                        <td style={{ padding: '1rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <div style={{
                              width: '2.25rem', height: '2.25rem',
                              backgroundColor: colors.indigoBg, border: `1px solid ${colors.indigoBorder}`,
                              borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                              fontWeight: '700', color: colors.indigoPrimary, fontSize: '0.75rem'
                            }}>
                              {(u.name || 'U').split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()}
                            </div>
                            <span style={{ fontWeight: '600', color: colors.textDark }}>{u.name}</span>
                          </div>
                        </td>
                        <td style={{ padding: '1rem' }}>
                          <span style={{ color: '#374151', display: 'block', fontWeight: '500' }}>{u.email}</span>
                          <span style={{ color: colors.textMuted, display: 'block', fontSize: '0.75rem', marginTop: '0.125rem' }}>{u.mobile}</span>
                        </td>
                        <td style={{ padding: '1rem' }}>
                          <span style={{
                            padding: '0.125rem 0.625rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: '600', border: '1px solid',
                            ...(u.user_type === 'Manager' ? { backgroundColor: '#eff6ff', color: '#1d4ed8', borderColor: '#dbeafe' } : { backgroundColor: '#f0fdf4', color: '#15803d', borderColor: '#dcfce7' })
                          }}>
                            {u.user_type}
                          </span>
                        </td>
                        <td style={{ padding: '1rem', textAlign: 'right' }}>
                          <div style={{ display: 'flex', gap: '0.25rem', justifyContent: 'flex-end' }}>
                            <button onClick={() => openEditModal(u)} style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', color: colors.indigoPrimary }} title="Edit Matrix">
                              <Edit style={{ width: '1rem', height: '1rem' }} />
                            </button>
                            <button onClick={() => handleDelete(u.id)} style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', color: '#dc2626' }} title="Purge Record">
                              <Trash2 style={{ width: '1rem', height: '1rem' }} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* RESPONSIVE MOBILE PANELS */}
            {isTablet && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {filteredUsers.map((u, index) => (
                  <div key={u.id} style={{
                    padding: '1rem', backgroundColor: colors.white, border: `1px solid ${colors.borderLight}`,
                    borderRadius: '0.75rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}>
                        <div style={{
                          width: '2.25rem', height: '2.25rem',
                          backgroundColor: colors.indigoBg, border: `1px solid ${colors.indigoBorder}`,
                          borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContext: 'center', justifyContent: 'center',
                          fontWeight: '700', color: colors.indigoPrimary, fontSize: '0.75rem'
                        }}>
                          {(u.name || 'U').split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()}
                        </div>
                        <div>
                          <span style={{ fontWeight: '600', color: colors.textDark, display: 'block', fontSize: '0.875rem' }}>{u.name}</span>
                          <span style={{ fontSize: '11px', color: colors.textMuted }}>Record Position #{index + 1}</span>
                        </div>
                      </div>
                      <span style={{
                        padding: '0.125rem 0.5rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: '600', border: '1px solid',
                        ...(u.user_type === 'Manager' ? { backgroundColor: '#eff6ff', color: '#1d4ed8', borderColor: '#dbeafe' } : { backgroundColor: '#f0fdf4', color: '#15803d', borderColor: '#dcfce7' })
                      }}>
                        {u.user_type}
                      </span>
                    </div>
                    <hr style={{ border: 0, borderTop: `1px solid ${colors.borderLight}`, margin: 0 }} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', fontSize: '0.75rem' }}>
                      <div><strong style={{ color: colors.textMuted }}>Email:</strong> <span style={{ color: colors.textDark }}>{u.email}</span></div>
                      <div><strong style={{ color: colors.textMuted }}>Mobile:</strong> <span style={{ color: colors.textDark }}>{u.mobile}</span></div>
                    </div>
                    <hr style={{ border: 0, borderTop: `1px solid ${colors.borderLight}`, margin: 0 }} />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                      <button onClick={() => openEditModal(u)} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.625rem', fontSize: '0.75rem', color: colors.indigoPrimary, backgroundColor: colors.indigoBg, border: 'none', borderRadius: '0.5rem', cursor: 'pointer' }}>
                        <Edit style={{ width: '0.875rem', height: '0.875rem' }} /> Modify
                      </button>
                      <button onClick={() => handleDelete(u.id)} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.625rem', fontSize: '0.75rem', color: '#b91c1c', backgroundColor: '#fef2f2', border: 'none', borderRadius: '0.5rem', cursor: 'pointer' }}>
                        <Trash2 style={{ width: '0.875rem', height: '0.875rem' }} /> Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>

      {/* ================= MODERN SLIDEOVER SIDE MODAL ================= */}
      {modalOpen && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 99999,
          backgroundColor: 'rgba(17, 24, 39, 0.4)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'flex-end',
          overflowY: 'auto'
        }}>
          <form 
            onSubmit={handleSubmit}
            style={{
              backgroundColor: colors.white,
              width: '100%',
              maxWidth: '36rem',
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              boxSizing: 'border-box'
            }}
          >
            {/* MODAL DOCUMENT CONTAINER HEADER */}
            <div style={{ padding: '1.25rem', borderBottom: `1px solid ${colors.borderLight}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#f9fafb' }}>
              <div>
                <h3 style={{ fontSize: '1rem', fontWeight: '700', color: colors.textDark, margin: 0 }}>
                  {editUser ? "Modify User Profile Matrix" : "Provision New Identity Node"}
                </h3>
                <p style={{ fontSize: '11px', color: colors.textMuted, marginTop: '0.125rem', margin: 0 }}>
                  Verify operational field parameters to maintain architecture constraints.
                </p>
              </div>
              <button 
                type="button"
                onClick={() => setModalOpen(false)}
                style={{ padding: '0.375rem', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', display: 'flex' }}
              >
                <X style={{ width: '1.25rem', height: '1.25rem' }} />
              </button>
            </div>

            {/* FORM BODY ENCLOSURE CONTAINER */}
            <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? '1.25rem' : '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem', boxSizing: 'border-box' }}>
              
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
                <Input label="Full Name *" value={form.name} onChange={(v) => updateField("name", v)} required />
                <Input label="Email Address *" type="email" value={form.email} onChange={(v) => updateField("email", v)} required />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
                <Input label="Mobile Endpoint *" value={form.mobile} onChange={(v) => updateField("mobile", v)} required />
                <Select label="Gender Identity *" value={form.gender} onChange={(v) => updateField("gender", v)} options={["Male", "Female", "Other"]} required />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
                <Select label="User Sizing Classification *" value={form.userType} onChange={(v) => updateField("userType", v)} options={["Manager", "Executive"]} required />
                {form.userType === "Executive" && (
                  <Select label="Allocate Supervisor Manager *" value={form.managerId} onChange={(v) => updateField("managerId", v)} options={managers.map(m => ({ label: m.name, value: m.id }))} required />
                )}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem', backgroundColor: '#f9fafb', padding: '1rem', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem' }}>
                <Input label="Secure Pass Key Sequence *" type="password" value={form.password} onChange={(v) => updateField("password", v)} required />
                <Input label="Confirm Verification *" type="password" value={form.confirmPassword} onChange={(v) => updateField("confirmPassword", v)} required />
              </div>

              {/* PERMISSION CHECKBOX MATRIX BLOCKS */}
              <div>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  Assign Structural Module Permissions
                </label>
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
                  gap: '0.5rem', 
                  maxHeight: '15rem', 
                  overflowY: 'auto', 
                  border: `1px solid ${colors.borderLight}`, 
                  borderRadius: '0.75rem', 
                  padding: '0.5rem', 
                  backgroundColor: 'rgba(249, 250, 251, 0.5)' 
                }}>
                  {sidebarComponents.map((p) => {
                    const isChecked = form.permissions.includes(p);
                    return (
                      <div 
                        key={p}
                        onClick={() => togglePermission(p)}
                        style={{
                          padding: '0.625rem',
                          border: `1px solid ${isChecked ? '#c7d2fe' : colors.borderLight}`,
                          borderRadius: '0.5rem',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          userSelect: 'none',
                          cursor: 'pointer',
                          backgroundColor: isChecked ? 'rgba(245, 243, 255, 0.6)' : colors.white,
                          color: isChecked ? colors.textDark : colors.textMuted
                        }}
                      >
                        <span style={{ fontSize: '0.75rem', fontWeight: '600', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p}</span>
                        <div style={{
                          width: '1rem', height: '1rem', borderRadius: '0.25rem',
                          border: `1px solid ${isChecked ? colors.indigoPrimary : '#d1d5db'}`,
                          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                          backgroundColor: isChecked ? colors.indigoPrimary : colors.white, color: colors.white
                        }}>
                          {isChecked && <Check style={{ width: '0.75rem', height: '0.75rem', strokeWidth: '3' }} />}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* FOOTER ACTIONS BAR CONTAINER */}
            <div style={{ padding: '1rem', borderTop: `1px solid ${colors.borderLight}`, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '0.75rem', backgroundColor: '#f9fafb' }}>
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                style={{ padding: '0.5rem 1rem', fontSize: '0.875rem', fontWeight: '500', border: `1px solid ${colors.borderLight}`, backgroundColor: colors.white, borderRadius: '0.75rem', cursor: 'pointer', color: '#374151' }}
              >
                Close Drawer
              </button>
              <button
                type="submit"
                style={{ padding: '0.5rem 1.25rem', fontSize: '0.875rem', fontWeight: '500', backgroundColor: colors.indigoPrimary, color: colors.white, border: 'none', borderRadius: '0.75rem', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' }}
              >
                {editUser ? "Commit Structural Updates" : "Save Active Identity Node"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

/* Reusable Dynamic Form Input Component */
const Input = ({ label, type = "text", value, onChange, required }) => (
  <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
    <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</label>
    <input 
      type={type} 
      required={required} 
      value={value} 
      onChange={(e) => onChange(e.target.value)} 
      style={{ 
        width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', border: '1px solid #e5e7eb', 
        borderRadius: '0.75rem', outline: 'none', backgroundColor: '#ffffff', color: '#111827', boxSizing: 'border-box' 
      }} 
    />
  </div>
);

/* Reusable Dynamic Option Selector Component */
const Select = ({ label, value, onChange, options, required }) => (
  <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
    <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</label>
    <select 
      value={value} 
      required={required}
      onChange={(e) => onChange(e.target.value)} 
      style={{ 
        width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', border: '1px solid #e5e7eb', 
        borderRadius: '0.75rem', outline: 'none', backgroundColor: '#ffffff', color: '#111827', boxSizing: 'border-box' 
      }}
    >
      <option value="">Select Option Scope</option>
      {options.map((o) =>
        typeof o === "string" ? (
          <option key={o} value={o}>{o}</option>
        ) : (
          <option key={o.value} value={o.value}>{o.label}</option>
        )
      )}
    </select>
  </div>
);

export default UserRoles;